import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { BoolToString } from 'components';
import atoms from 'ctsutheme/components/atoms';

const { Divider } = atoms;

export const ViewFundingDetails = ({ fundingInfo }) => {
  const {
    fundingSource,
    fundingTypeNumber,
    accrualCap,
    endDate,
    fundingType,
    fundingStatusDate,
    lapsGrant,
    ncorpDollarValue,
    nonCredit,
    specify,
    startDate,
    isCollectInOpen,
    collectType,
    fundingStatus
  } = fundingInfo;

  const getDecimalAmount = amt => <div>&#36; {amt}</div>;

  return (
    <>
      <FormViewContent
        primaryText="Funding Source"
        secondaryText={fundingSource}
        name="fundingSource"
      />
      <Divider />
      <FormViewContent
        primaryText="Funding Type"
        secondaryText={fundingType}
        name="fundingType"
      />
      <Divider />
      <FormViewContent
        primaryText="Funding Type Number"
        secondaryText={fundingTypeNumber}
        name="fundingTypeNumber"
      />
      <Divider />
      <FormViewContent
        primaryText="Specify"
        secondaryText={specify}
        name="specify"
      />
      <Divider />
      <FormViewContent
        primaryText="Dollar value NCTN"
        secondaryText={nonCredit && getDecimalAmount(parseFloat(nonCredit).toFixed(2))}
        name="nonCredit"
      />
      <Divider />
      <FormViewContent
        primaryText="Dollar value NCORP"
        secondaryText={ncorpDollarValue && getDecimalAmount(parseFloat(ncorpDollarValue).toFixed(2))}
        name="ncorpDollarValue"
      />
      <Divider />
      <FormViewContent
        primaryText="LAPS Grant"
        secondaryText={lapsGrant}
        name="lapsGrant"
      />
      <Divider />
      <FormViewContent
        primaryText="Collect in OPEN"
        secondaryText={(<BoolToString boolValue={isCollectInOpen} />)}
        name="isCollectInOpen"
      />
      <Divider />
      <FormViewContent
        primaryText="Start Date"
        secondaryText={startDate}
        name="startDate"
      />
      <Divider />
      <FormViewContent
        primaryText="End Date"
        secondaryText={endDate}
        name="endDate"
      />
      <Divider />
      <FormViewContent
        primaryText="Funding Status"
        secondaryText={fundingStatus}
        name="fundingStatus"
      />
      <Divider />
      <FormViewContent
        primaryText="Funding Status Date"
        secondaryText={fundingStatusDate}
        name="fundingStatusDate"
      />
      <Divider />
      <FormViewContent
        primaryText="Accrual Cap"
        secondaryText={accrualCap}
        name="accrualCap"
      />
      <Divider />
      <FormViewContent
        primaryText="Collect Type"
        secondaryText={collectType}
        name="collectType"
      />
    </>
  );
};
